'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { getProductMinQuantity } from '@eliadmin/core/src/utils/product-utils';
import { ProductAccessoriesCardInDialog as CoreProductAccessoriesCardInDialog } from '../../../../node_modules/@eliadmin/core/src/components/product/detail/product-accesories';
import {
  normalizeRsMotoAccessoryGroups,
  type RsMotoAccessoryProduct,
} from '../../../lib/rsmoto-accessories';

type AccessoryListProps = {
  accessories: RsMotoAccessoryProduct[];
};

function AccessoryList({ accessories }: AccessoryListProps) {
  const selectedAccessories = useVariantsStore(state => state.selectedAccessories);
  const updateSelectedAccessories = useVariantsStore(state => state.updateSelectedAccessories);
  const accessoriesQuantities = useVariantsStore(state => state.accessoriesQuantities);
  const updateAccessoriesQuantities = useVariantsStore(state => state.updateAccessoriesQuantities);

  return (
    <div className="space-y-4">
      {accessories.map(accessory => (
        <CoreProductAccessoriesCardInDialog
          key={`${accessory.accessory_product?.type ?? 'accessory'}-${accessory.id}`}
          accessory={accessory}
          quantity={accessoriesQuantities?.[accessory.id] ?? getProductMinQuantity(accessory)}
          updateQuantity={(quantity: number) => {
            updateAccessoriesQuantities({ [accessory.id]: quantity });
          }}
          isSelected={!!selectedAccessories?.some(selected => selected.id === accessory.id)}
          onSelect={() => updateSelectedAccessories(accessory)}
        />
      ))}
    </div>
  );
}

export const ProductAccessories = ({ inDialog = false }: { inDialog?: boolean }) => {
  const { t } = useTranslations();
  const product = useVariantsStore(state => state.product);
  const showRecommendedAccessories = useGlobalStore(
    state => state.templateSettings.product_detail?.product_recommended_accessories?.enabled,
  );
  const { optional, required } = normalizeRsMotoAccessoryGroups(product);

  const visibleOptional = showRecommendedAccessories ? optional : [];
  if (!required.length && !visibleOptional.length) return null;

  return (
    <div className={inDialog ? 'space-y-4' : 'w-full space-y-5'}>
      {!!required.length && (
        <section className="rounded-lg border border-amber-400 bg-amber-50/70 p-3">
          <h2 className="text-sm font-bold text-amber-950">Povinné príslušenstvo</h2>
          <p className="mb-3 mt-1 text-xs text-amber-950/80">
            Nepridá sa automaticky. Označte položky, ktoré chcete vložiť do košíka.
          </p>
          <AccessoryList accessories={required} />
        </section>
      )}

      {!!visibleOptional.length && (
        <section>
          <h2 className="mb-3 text-sm font-bold">{t('text2276')}</h2>
          <AccessoryList accessories={visibleOptional} />
        </section>
      )}
    </div>
  );
};

export const ProductAccessoriesCardInDialog = CoreProductAccessoriesCardInDialog;
